import React from "react";
import { Link } from "react-router-dom";

class OneTime extends React.Component {
  render() {
    return (
      <div className="col-lg-6">
        <div className="price_box text-center active mt-3 p-5">
          <div className="price_name">
            <h1 className="getbluetitle">ONE-TIME TRAVELER</h1>
          </div>
          <div className="plan_price pb-3 mt-4 pt-2">
            <strong className="getmiddle">UNLIMITED GLOBAL WIFI</strong>
            <div style={{ clear: "both" }} />

            <h1 className="text-custom mb-0 font-weight-normal">$9.95</h1>
            <p className="text-muted mb-0">PER DAY</p>
          </div>
          <div className="plan_price pb-3 mt-4 pt-2">
            <strong className="getmiddle">UNLIMITED GLOBAL WIFI</strong>
            <div style={{ clear: "both" }} />
            <h1 className="text-custom mb-0 font-weight-normal">INCLUDED</h1>
            <p className="text-muted mb-0">FOR RENT DAY</p>
          </div>

          <div className="plan_price pb-3 mt-4 pt-2">
            <strong className="getmiddle">Connect 10 devices at a time</strong>
            <div style={{ clear: "both" }} />
            <h1 className="text-custom mb-0 font-weight-normal">
              <i className="mdi mdi-check" />
            </h1>
          </div>

          <div className="plan_price pb-3 mt-4 pt-2">
            <strong className="getmiddle">PAY FOR DAYS YOU USE</strong>
            <div style={{ clear: "both" }} />
            <h1 className="text-custom mb-0 font-weight-normal">
              <i className="mdi mdi-check" />
            </h1>
          </div>

          <div className="plan_price pb-3 mt-4 pt-2">
            <strong className="getmiddle">No Sim Card Changes Required</strong>
            <div style={{ clear: "both" }} />
            <h1 className="text-custom mb-0 font-weight-normal">
              <i className="mdi mdi-check" />
            </h1>
          </div>

          <div className="plan_price pb-3 mt-4 pt-2">
            <strong className="getmiddle">Secure, Fast, Easy Access</strong>
            <div style={{ clear: "both" }} />
            <h1 className="text-custom mb-0 font-weight-normal">
              <i className="mdi mdi-check" />
            </h1>
          </div>

          <div className="mt-5">
            <Link to="/rent" className="btn btn-custom-buy-get w-100">
              RENT NOW
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default OneTime;



// WEBPACK FOOTER //
// ./src/reusable/OneTime.js